import { HttpService, LanguageService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';

interface LocalizationDTO {
  language: string;
  locale: string;
}

function setupLocalization(): Promise<void> {
  return HttpService.get(APPLICATION_ENDPOINTS.GET_LOCALE_AND_LANGUAGE, {})
    .then(response => {
      const { locale } = response.body as LocalizationDTO;
      LanguageService.setCurrentLanguage(locale);
    });
}

export {
  setupLocalization,
};

